import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: inline-block;
  margin-left: ${({ marginLeft }) => marginLeft || '8px'};
	vertical-align: middle;

	& > i::before {
		background-color: ${({ theme }) => theme.colors.info.normal} !important;
	}
`;
